import { smoothScrollToElement } from "./functions";

export function finishLoadingBar (url) {
    clearTimeout(window.progressBarTimeout);
    $('.customer-name').text($('[name=fname]').val());
    var preApproved = false; // (url.indexOf('sunny.co.uk') !== -1);
    var completeClass = (preApproved ? 'inter' : 'complete');
    var container = $('#application_searching_container');
    container.addClass(completeClass);
    container.find('#progress-bar-circle').addClass(completeClass);
    container.find('.end-paragraph').addClass(completeClass);
    container.find('h1, h2').addClass(completeClass);
    if (preApproved) {
        var i = 5;
        var textEl = container.find('.inter-loader-container .text');
        var int = setInterval(function () {
            if (i == 0) {
                clearInterval(int);
                return;
            }
            i--;
            textEl.text(i);
        }, 1000);
    }
}

export function startLoadingBar() {
    var timings = {
        100: 7000,
        90: 6800,
        80: 6300,
        70: 5000,
        51: 4000,
        46: 2000,
        40: 1000,
        30: 500,
        20: 200,
        0: 200
    };
    var getTiming = function (iterator) {
        for (var k in timings) {
            if (timings.hasOwnProperty(k)) {
                k = parseInt(k, 10);
                if (timings.hasOwnProperty(k) && iterator < k) {
                    return timings[k];
                }
            }
        }
    };
    // Start the loop
    var progressBarCircle = $('#progress-bar-circle').first();
    if (progressBarCircle.length === 1) {
        var text = progressBarCircle.find('.text');
        var i = 0;
        var timeoutLoop = function () {
            if (i >= 100) {
                return false;
            }
            i++;
            var timing = getTiming(i);
            text.html((i < 10 ? '&nbsp;' : '') + i + '<small>%</small>');
            window.progressBarTimeout = setTimeout(timeoutLoop, timing);
        };
        timeoutLoop();
    }
}

export function showLoadingBar()
{
    let section = $('.apply-page-section');
    smoothScrollToElement($('body'));
    // let toFadeOut = section.find('.form-top-section-content, .page');
    // Animate form opacity to 0
    section.addClass('hidden');
    let spinner = $('.spinner-section');
    startLoadingBar();
    spinner.removeClass('hidden');
}
